import React from 'react';

import { SignUp } from '@/modules/user/components/SignUp';

const SignUpPage = () => <SignUp />;

export default SignUpPage;
